import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-imports',
  templateUrl: './imports.page.html',
  styleUrls: ['./imports.page.scss'],
})
export class ImportsPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
